import { useRouter } from 'next/router';
import { useEffect, useState, useRef } from 'react';
import { useAuth0SessionUser } from '@hooks/useAuth0SessionUser';

export const useInAppAuth = () => {
  // Identity only: this decides whether to send a legacy in-app visitor
  // through login, which their membership has no say in. It also renders
  // above the query client, where useAuth0User cannot be used (FFH-3019).
  const { user, isLoading } = useAuth0SessionUser();
  const router = useRouter();
  const [isInAppAuthenticating, setIsInAppAuthenticating] = useState(false);
  const hasAttemptedAuth = useRef(false);

  useEffect(() => {
    const { source } = router.query;

    // Prevent infinite loops - only attempt once per session
    if (
      source === 'inapp' &&
      !user &&
      !isLoading &&
      !hasAttemptedAuth.current
    ) {
      hasAttemptedAuth.current = true;
      setIsInAppAuthenticating(true);

      const currentPath = router.asPath;
      window.location.href = `/auth/login?source=inapp&returnTo=${encodeURIComponent(
        currentPath
      )}`;
    }
  }, [user, isLoading, router.query]);

  // Reset the attempt flag if user successfully logs in
  useEffect(() => {
    if (user) {
      hasAttemptedAuth.current = false;
      setIsInAppAuthenticating(false);
    }
  }, [user]);

  const shouldShowLoading =
    router.query.source === 'inapp' && (isLoading || isInAppAuthenticating);

  return {
    user,
    isLoading: shouldShowLoading
  };
};
